import React from "react";

/**
 * Ornamen geometri Islam (bintang 8 mata / girih) untuk pemisah seksyen.
 * variant: "divider" | "star" | "arch"
 */
export default function Ornament({ variant = "divider", className = "" }) {
  if (variant === "star") {
    return (
      <span className={`orn orn--star ${className}`} aria-hidden="true">
        <svg viewBox="0 0 48 48" width="20" height="20">
          <path
            d="M24 2l5.6 12.8L42 8.4l-6.4 12.4L48 24l-12.4 3.2L42 39.6l-12.4-6.4L24 46l-5.6-12.8L6 39.6l6.4-12.4L0 24l12.4-3.2L6 8.4l12.4 6.4L24 2z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.4"
          />
        </svg>
      </span>
    );
  }

  if (variant === "arch") {
    return (
      <span className={`orn orn--arch ${className}`} aria-hidden="true">
        <svg viewBox="0 0 120 160" width="120" height="160">
          <path
            d="M8 158V72C8 36 31 8 60 8s52 28 52 64v86"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.2"
          />
          <path
            d="M22 158V76c0-30 17-52 38-52s38 22 38 52v82"
            fill="none"
            stroke="currentColor"
            strokeWidth="0.8"
            opacity="0.6"
          />
        </svg>
      </span>
    );
  }

  return (
    <span className={`orn orn--divider ${className}`} aria-hidden="true">
      <svg viewBox="0 0 220 24" width="220" height="24">
        <path d="M0 12h72" stroke="currentColor" strokeWidth="1" opacity="0.5" />
        <path d="M148 12h72" stroke="currentColor" strokeWidth="1" opacity="0.5" />
        <path
          d="M110 2l4.2 5.8L121 4l-2.6 6.6L126 12l-7.6 1.4L121 20l-6.8-3.8L110 22l-4.2-5.8L99 20l2.6-6.6L94 12l7.6-1.4L99 4l6.8 3.8L110 2z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.1"
        />
        <circle cx="84" cy="12" r="2" fill="currentColor" opacity="0.7" />
        <circle cx="136" cy="12" r="2" fill="currentColor" opacity="0.7" />
      </svg>
    </span>
  );
}
